var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6232 0.380639C17.8645 0.624435 18 0.95505 18 1.29978C18 1.64451 17.8645 1.97512 17.6232 2.21892L7.32832 12.6194C7.08699 12.8631 6.75973 13 6.4185 13C6.07727 13 5.75001 12.8631 5.50869 12.6194L0.361238 7.41914C0.126825 7.17395 -0.00288337 6.84555 4.86468e-05 6.50468C0.00298066 6.16381 0.138319 5.83774 0.376914 5.5967C0.615509 5.35566 0.93827 5.21893 1.27568 5.21597C1.61309 5.21301 1.93816 5.34405 2.18086 5.58086L6.4185 9.86194L15.8036 0.380639C16.0449 0.136916 16.3722 0 16.7134 0C17.0546 0 17.3819 0.136916 17.6232 0.380639Z",
    fill: "#303261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.92cf8cad0392b09d39a5b902af9596e2.svg";
export { ForwardRef as ReactComponent };